const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const pages = [
  {
    header: "\"Ryan\"",
    audio: `${BASE_URL}/audio/audio1.mp3`,
    textBase: 'page1',
  },
  {
    header: "\"April\"",
    audio: `${BASE_URL}/audio/audio2.mp3`,
    textBase: 'page2',
  },
  {
    header: "\"Evelyn\"",
    audio: `${BASE_URL}/audio/audio3.mp3`,
    textBase: 'page3',
  }
];

export default pages;